import { Component, EventEmitter, Input, OnInit, Output , numberAttribute } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js/auto';
import { chartView } from '../global-variables';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-chart-view',
    templateUrl: './chart-view.component.html',
    styleUrls: ['./chart-view.component.scss'],
    imports: [FormsModule]
})
export class ChartViewComponent implements OnInit {
  @Input('values')
  set values(values: { xValues: string[], yValues: number[] , minScale: number, yTitle: string, gradientColor: string, chartBorderColor: string, chartName: string, chartId?: string }) {
    this.xValues = values.xValues;
    this.yValues = values.yValues;
    this.minScale = values.minScale;
    this.gradientColor = values.gradientColor;
    this.chartBorderColor = values.chartBorderColor;
    this.yTitle = values.yTitle;
    this.chartId = values.chartId || 'chartId';
    this.chartName = values.chartName;
    this.onChange()
  }
  id = 'chart';
  chartId: string = '';
  chartData: Chart | null = null;
  chartName: string = "";
  xValues: string[] = []
  yTitle: string = ""
  gradientColor: string = ""
  chartBorderColor: string = ""
  yValues: number[] = []
  minScale: number = 0
  canvas: any;
  // plot: keyof XValues = chartView.plot as keyof XValues;
  @Output() newItemEvent = new EventEmitter();
  constructor() {

  }
  fullView() {
    chartView.fullView = !chartView.fullView;
    this.newItemEvent.emit();
  }

  ngOnInit() {
    chartView.scales.yAxis.title.text  = this.yTitle
    chartView.scales.yAxis.min  = 0;
    chartView.scales.yAxis.max = 100;
    // this.prepareChartData();
  }

  ngAfterViewInit(): void {
    const canvas = document.getElementById(this.chartId);
    if (canvas) {
      this.prepareChartData(this.chartId);
    }
  }

  prepareChartData(chartId: string) {
    this.canvas = <HTMLCanvasElement>document.getElementById(chartId);
    const ctx = this.canvas?.getContext('2d');
    const gradient = ctx?.createLinearGradient(0, 1, this.xValues.length, chartView.scales.yAxis.max);
    gradient?.addColorStop(0, this.gradientColor);
    gradient?.addColorStop(1, '#E377C20F');
    const data: ChartConfiguration = {
      type: 'line',
      data: {
        labels: this.xValues,
        datasets: [
          {
            yAxisID: 'yAxis',
            xAxisID: 'xAxis',
            backgroundColor: gradient,
            borderColor: gradient,
            pointBackgroundColor: this.chartBorderColor,
            pointBorderColor: 'white',
            pointRadius: 8,
            pointBorderWidth: 2,
            pointHoverBorderColor: 'white',
            data: this.yValues,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        aspectRatio: 573/300,
        plugins: chartView.plugins,
        scales: chartView.scales,
      }
    }
    this.chartData = new Chart(this.chartId, data);
  }
  ngDestroy() {
    if (this.chartData) {
      this.chartData.destroy();
      this.chartData = null;
    }
  }

  onChange() {
    if (this.chartData) {
      this.chartData.data.labels = this.xValues;
      this.chartData.data.datasets[0].data = this.yValues;
      this.chartData.update();
    }
  }
}
